(function () {
  'use strict';

  // ── Variant IDs : V[model][size][type] ──────────────────────────────────────
  var V = {
    teddy: {
      'XS - 17cm': { seul: 55506461163860, avec: 55506749260116 },
      'S - 22cm':  { seul: 55506461196628, avec: 55506749292884 },
      'M - 28cm':  { seul: 55506461229396, avec: 55506749325652 }
    },
    polka: {
      'XS - 17cm': { seul: 55506442715476, avec: 55506746212692 },
      'S - 22cm':  { seul: 55506442748244, avec: 55506746245460 },
      'M - 28cm':  { seul: 55506442781012, avec: 55506746278228 }
    }
  };

  var PRICES = { seul: 27, avec: 35 };

  // ── Helpers ─────────────────────────────────────────────────────────────────
  function getOffer() {
    var el = document.querySelector('input[name="mrb_bundle"]:checked');
    return el ? parseInt(el.value, 10) : 1;
  }
  function getVal(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }
  function vid(model, size, type) {
    return V[model] && V[model][size] && V[model][size][type] || null;
  }

  // ── Panneaux ─────────────────────────────────────────────────────────────────
  function refreshPanels() {
    var offer = getOffer();
    [1, 2, 3].forEach(function (i) {
      var p = document.getElementById('mrb-panel-' + i);
      if (p) p.hidden = (i !== offer);
    });
  }

  // ── Images ───────────────────────────────────────────────────────────────────
  function setImg(id, model, type) {
    var img = document.getElementById(id);
    if (!img) return;
    var IMGS = window.MRB_IMGS || {};
    var src = IMGS[model] && IMGS[model][type];
    if (!src || img.getAttribute('src') === src) return;
    img.style.opacity = '0';
    setTimeout(function () { img.src = src; img.style.opacity = '1'; }, 150);
  }

  function refreshImages() {
    // O1 — toujours avec chouchou
    setImg('mrb-img-o1-b1', getVal('o1_b1_model') || 'teddy', 'avec');
    // O2 — selon type choisi indépendamment
    setImg('mrb-img-o2-b1', getVal('o2_b1_model') || 'teddy', getVal('o2_b1_type') || 'seul');
    setImg('mrb-img-o2-b2', getVal('o2_b2_model') || 'teddy', getVal('o2_b2_type') || 'seul');
    // O3 — toujours avec chouchou
    setImg('mrb-img-o3-b1', getVal('o3_b1_model') || 'teddy', 'avec');
    setImg('mrb-img-o3-b2', getVal('o3_b2_model') || 'teddy', 'avec');
  }

  // ── Prix dynamique O2 ────────────────────────────────────────────────────────
  function refreshPriceO2() {
    var t1 = getVal('o2_b1_type') || 'seul';
    var t2 = getVal('o2_b2_type') || 'seul';
    var el = document.getElementById('mrb-price-o2');
    if (el) el.textContent = ((PRICES[t1] || 27) + (PRICES[t2] || 27)).toFixed(2).replace('.', ',') + ' €';
  }

  // ── Normalisation du prénom (même logique que mv-perso) ─────────────────────
  function normalizeName(value) {
    if (!value) return '';
    value = value.trim().replace(/\s+/g, ' ');
    if (!value) return '';
    value = value.toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  // ── Construction du panier ───────────────────────────────────────────────────
  function buildItems() {
    var offer = getOffer();
    var items = [];

    if (offer === 1) {
      var m = getVal('o1_b1_model') || 'teddy';
      var s = getVal('o1_b1_size')  || 'XS - 17cm';
      var id = vid(m, s, 'avec');
      if (!id) return null;
      items.push({ id: id, quantity: 1, properties: { '_cadeau': 'Pochon cadeau offert' } });
    }

    if (offer === 2) {
      var b1m = getVal('o2_b1_model') || 'teddy', b1s = getVal('o2_b1_size') || 'XS - 17cm', b1t = getVal('o2_b1_type') || 'seul';
      var b2m = getVal('o2_b2_model') || 'teddy', b2s = getVal('o2_b2_size') || 'XS - 17cm', b2t = getVal('o2_b2_type') || 'seul';
      var id1 = vid(b1m, b1s, b1t), id2 = vid(b2m, b2s, b2t);
      if (!id1 || !id2) return null;
      if (id1 === id2) {
        items.push({ id: id1, quantity: 2, properties: { '_cadeau': 'Pochon cadeau offert' } });
      } else {
        items.push({ id: id1, quantity: 1, properties: { '_cadeau': 'Pochon cadeau offert' } });
        items.push({ id: id2, quantity: 1 });
      }
    }

    if (offer === 3) {
      var b1m = getVal('o3_b1_model') || 'teddy', b1s = getVal('o3_b1_size') || 'XS - 17cm';
      var b2m = getVal('o3_b2_model') || 'teddy', b2s = getVal('o3_b2_size') || 'XS - 17cm';
      var dogNameRaw = (document.getElementById('mrb-dog-name') || {}).value || '';
      var dogName = normalizeName(dogNameRaw);
      var persoOn = getVal('mrb_perso_on') || '1';
      var id1 = vid(b1m, b1s, 'avec'), id2 = vid(b2m, b2s, 'avec');
      if (!id1 || !id2) return null;

      var p1 = { '_cadeau': '2 Pochons cadeaux offerts' };
      var p2 = {};
      if (persoOn === '1') { p1['Nom brodé'] = dogName; }
      else                  { p2['Nom brodé'] = dogName; }

      if (id1 === id2) {
        items.push({ id: id1, quantity: 2, properties: Object.assign({}, p1, p2) });
      } else {
        items.push({ id: id1, quantity: 1, properties: p1 });
        items.push({ id: id2, quantity: 1, properties: p2 });
      }
    }

    return items;
  }

  // ── Ajout au panier ──────────────────────────────────────────────────────────
  function addToCart() {
    var items = buildItems();
    if (!items || !items.length) { alert('Veuillez sélectionner vos options.'); return; }

    var cta = document.getElementById('mrb-cta');
    var orig = cta.innerHTML;
    cta.disabled = true;
    cta.innerHTML = '<span style="letter-spacing:.1em">Ajout en cours…</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        cta.disabled = false; cta.innerHTML = orig;
        alert(data.description || 'Erreur lors de l\'ajout au panier.');
        return;
      }
      cta.innerHTML = '<span style="letter-spacing:.1em">✓ Ajouté !</span>';
      cta.style.background = '#5A7A50';
      if (typeof aovCartDrawerUpdateAndOpen === 'function') aovCartDrawerUpdateAndOpen();
      else if (typeof aovCartDrawerOpen === 'function') aovCartDrawerOpen();
      setTimeout(function () { cta.innerHTML = orig; cta.style.background = ''; cta.disabled = false; }, 2500);
    })
    .catch(function () {
      cta.disabled = false; cta.innerHTML = orig;
      alert('Une erreur est survenue. Veuillez réessayer.');
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('input[name="mrb_bundle"]').forEach(function (r) {
      r.addEventListener('change', refreshPanels);
    });

    ['o1_b1_model', 'o2_b1_model', 'o2_b2_model', 'o3_b1_model', 'o3_b2_model'].forEach(function (name) {
      document.querySelectorAll('input[name="' + name + '"]').forEach(function (r) {
        r.addEventListener('change', refreshImages);
      });
    });

    ['o2_b1_type', 'o2_b2_type'].forEach(function (name) {
      document.querySelectorAll('input[name="' + name + '"]').forEach(function (r) {
        r.addEventListener('change', function () { refreshImages(); refreshPriceO2(); });
      });
    });

    var cta = document.getElementById('mrb-cta');
    if (cta) cta.addEventListener('click', addToCart);

    refreshPanels();
    refreshImages();
    refreshPriceO2();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
